// Real pages from DRUM READY Volume 1 (WebP in Impultienda Recursos, store DRUM READY).
const R = 'https://aekpgsbqjzqntlbucbts.supabase.co/storage/v1/object/public/store-resources/81daa30f-3f61-480f-a536-2affd069f30c/';
export const PAGE_COVER = R + '1792782700639_dr-vol1-p01-cover-d26bc477.webp';
export const PAGE_YEARPLAN = R + '1792782704605_dr-vol1-p05-yearplan-18a0fd32.webp';
export const PAGE_LESSON1 = R + '1792782708682_dr-vol1-p12-lesson1-7b74f758.webp';
export const PAGE_LESSON7 = R + '1792782716301_dr-vol1-p24-lesson7-3913a377.webp';
export const PAGE_WORKSHEET2 = R + '1792782712392_dr-vol1-p15-worksheet2-e5b7b549.webp';
export const PAGE_BLUEPRINTS = R + '1792785840570_dr-vol1-p09-blueprints-fec8c6ff.webp';
export const PAGE_LESSON_NOTES = R + '1792785847467_dr-vol1-p11-lessonnotes-63bad6ca.webp';
export const PAGE_TEST_A = R + '1792785852193_dr-vol1-p36-testa-f5015630.webp';
export const PAGE_ANSWER_KEY = R + '1792785855815_dr-vol1-p38-answerkey-7d9b62f0.webp';
export const pageSamples: Array<{
  src: string;
  label: string;
  title: string;
  text: string;
}> = [{
  src: PAGE_COVER,
  label: 'Volume 1 · Cover',
  title: 'Studio Year Plan & 12 Ready-to-Teach Lessons',
  text: 'Three tracks – Young Beginners 6–9, Older Beginners 10–14, Teens & Adults – with 30, 45 and 60-minute lessons, printable worksheets and tests with answer keys.'
}, {
  src: PAGE_YEARPLAN,
  label: 'Year plan · Page 5',
  title: '36-Week Plan · Young Beginners (6–9)',
  text: 'Week by week, from Meet the Drum Kit to the studio showcase and level-up check – so you always know what comes next.'
}, {
  src: PAGE_LESSON1,
  label: 'Lesson 1 · Page 12',
  title: 'Meet the Drum Kit · 30 min',
  text: 'Young Beginners (6–9): goal, materials, a minute-by-minute plan, a counting chart and a word-for-word teacher script.'
}, {
  src: PAGE_LESSON7,
  label: 'Lesson 7 · Page 24',
  title: 'First Fills · 45 min',
  text: 'Older Beginners (10–14): 1-beat and 2-beat fills written as clear “1 e & a” counting charts with sticking, plus a teacher script.'
}, {
  src: PAGE_WORKSHEET2,
  label: 'Worksheet 2 · Page 15',
  title: 'Beat Math in 3 Levels',
  text: 'The same skill at three levels, so every student in your studio can work on it – at their own pace.'
}, {
  src: PAGE_BLUEPRINTS,
  label: 'Lesson blueprints · Page 9',
  title: '30 / 45 / 60-Minute Lessons, Minute by Minute',
  text: 'A ready timing template for each age group, so every lesson has a clear shape.'
}, {
  src: PAGE_LESSON_NOTES,
  label: 'Lesson notes · Page 11',
  title: 'Lesson Notes & Weekly Assignment',
  text: 'Groove of the week, tempo goal, a 5-day practice plan and a note to parents – ready to print.'
}, {
  src: PAGE_TEST_A,
  label: 'Test A · Page 36',
  title: 'Test A · Young & Older Beginners',
  text: '10 questions to check what each student has learned.'
}, {
  src: PAGE_ANSWER_KEY,
  label: 'Answer key · Page 38',
  title: 'Answer Key (Teacher Copy)',
  text: 'Answers for Test A, Test B and every worksheet in Volume 1.'
}];
